import { StatusBanner } from './StatusBanner';
import { MODES } from '../utils/modes';
import type { AnonymizationMode } from '../types/api';

interface Props {
  filename: string;
  findings: number;
  mode: AnonymizationMode;
  onStartOver: () => void;
}

export function DoneStep({ filename, findings, mode, onStartOver }: Props) {
  const modeLabel = MODES.find((m) => m.value === mode)?.label ?? mode;
  const noun = findings === 1 ? 'substituição' : 'substituições';

  return (
    <div className="card">
      <h2 className="card-title">Concluído com Sucesso</h2>
      <StatusBanner status={{ kind: 'success', message: '' }}>
        ✓ <strong>{filename}</strong> foi processado com {findings} {noun} usando{' '}
        <strong>{modeLabel}</strong> e está pronto para download.{' '}
        {mode === 'pseudonymize' ? (
          <>
            O mapeamento HMAC é mantido sob isolamento por chave de organização —
            para anonimização irreversível conforme LGPD Art. 12, destrua a chave
            após o processamento.
          </>
        ) : (
          <>
            Os valores originais não foram preservados em nenhuma forma
            recuperável: não existe chave capaz de revertê-los, o que atende à
            anonimização prevista no Art. 12 da LGPD.
          </>
        )}
      </StatusBanner>
      <div className="actions">
        <button className="btn btn-primary" onClick={onStartOver}>
          Processar Novo Arquivo
        </button>
      </div>
    </div>
  );
}
